import React from "react";

/**
 * Minimal inline SVG icon set — avoids pulling in an external icon library
 * (and any React-version-mismatch issues that can come with it).
 * Each icon accepts `size` and forwards any other svg props (e.g. className).
 */

const base = (size) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
});

export function Users({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

export function ClipboardList({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <rect x="8" y="2" width="8" height="4" rx="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="M9 12h6" />
      <path d="M9 16h6" />
      <path d="M9 8h1" />
    </svg>
  );
}

export function Stethoscope({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M4.5 3v6a4.5 4.5 0 0 0 9 0V3" />
      <path d="M9 15a5 5 0 0 0 10 0v-2" />
      <circle cx="19" cy="10" r="2" />
    </svg>
  );
}

export function LogOut({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
}

export function Sparkles({ size = 18, ...props }) {
  return (
    <svg {...base(size)} fill="currentColor" stroke="none" {...props}>
      <path d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8L12 2z" />
      <path d="M19 14l0.7 2 2 0.7-2 0.7-0.7 2-0.7-2-2-0.7 2-0.7z" />
    </svg>
  );
}

export function Building2({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M6 22V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v18" />
      <path d="M14 9h5a1 1 0 0 1 1 1v12" />
      <path d="M9 6h.01M9 10h.01M9 14h.01M9 18h.01" />
      <path d="M17 12h.01M17 16h.01M17 20h.01" />
    </svg>
  );
}

export function CheckCircle2({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

export function AlertCircle({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}

export function Search({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

export function Plus({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

export function MoreVertical({ size = 18, ...props }) {
  return (
    <svg {...base(size)} fill="currentColor" stroke="none" {...props}>
      <circle cx="12" cy="5" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <circle cx="12" cy="19" r="1.5" />
    </svg>
  );
}

export function Home({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M3 11.5L12 4l9 7.5" />
      <path d="M5 10v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V10" />
    </svg>
  );
}

export function Menu({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

export function X({ size = 18, ...props }) {
  return (
    <svg {...base(size)} {...props}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}